// extracted by mini-css-extract-plugin
export default {"Search":"PUSn5iZnDkYTWlQOiQP7","Search__input":"OsXMJ0vczOdqTsOKDPRZ","Search__button":"izwnP7BL7gFjE2EKOq2W"};